import { createFileRoute } from "@tanstack/react-router"
import { GorgiasIntegrationModal } from "modules/settings/components/integrations/gorgias/GorgiasIntegrationModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/gorgias/connect")({
  component: GorgiasIntegrationModal,
})
